import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import Text from '~/components/typographies/Text';
import IconClose from '~/icons/icon-close.svg?react';
import IconDelete from '~/icons/icon-delete.svg?react';
import { useResetFilters } from '~/state/tableFilters';

interface Props {
  disabled?: boolean;
  inline?: boolean;
  className?: string;
  onReset?: () => void;
}

const ClearFiltersButtonInner: React.FC<Props & { onReset: () => void }> = ({
  disabled,
  inline,
  className,
  onReset,
}) => {
  const { t } = useTranslation();

  if (disabled) return null;

  return (
    <Button
      className={className}
      action="destructive"
      onClick={onReset}
      Icon={inline ? IconClose : IconDelete}
      variant="ghost"
      size="medium"
    >
      <Text variant="body2" weight="semibold">
        {inline ? t('CLEAR_FILTERS') : t('CLEAR_ALL_FILTERS')}
      </Text>
    </Button>
  );
};

const ClearFiltersButtonWithHook: React.FC<Omit<Props, 'onReset'>> = (props) => {
  const resetFilters = useResetFilters();
  return <ClearFiltersButtonInner {...props} onReset={resetFilters} />;
};

const ClearFiltersButton: React.FC<Props> = ({ onReset, ...props }) => {
  if (onReset) return <ClearFiltersButtonInner {...props} onReset={onReset} />;
  return <ClearFiltersButtonWithHook {...props} />;
};

export default ClearFiltersButton;
